import React, { useEffect, useState } from 'react';
import { Footer } from '../components/Footer';
import { Navigation } from '../components/Navigation';
import { highlightJSON } from '../utils/highlightJSON';
const pageData = {
  $schema: 'https://schema.org/ContactPage',
  name: 'Andoe / Contact',
  frontmatter: {
    page: 'Contact',
    topic: 'Support & Demo',
    status: 'Active'
  },
  hero: {
    kicker: 'Andoe / Contact',
    headline: 'Talk to our team.',
    lede: 'We can set up a platform demo using your choice of prompt.'
  },
  sections: [{
    title: 'Request a Demo',
    deck: 'See Andoe with your own data.',
    form: {
      fields: ['full_name', 'work_email'],
      action: 'submit_demo_request'
    }
  }],
  contact: {
    email: 'jason@andoe.work'
  }
};
export function ContactPage() {
  const [formData, setFormData] = useState({
    fullName: '',
    workEmail: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState('');
  const [jsonHtml, setJsonHtml] = useState('');
  useEffect(() => {
    setJsonHtml('<span class="c">// how to reach us, as structured data</span>\n\n' + highlightJSON(pageData));
  }, []);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    try {
      const GOOGLE_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzjxh1RfuSYw04chiQwIV6cjo7lN-9ulD4KZKZb-iVVUhxMsN8OqWjaiOSPzSndOpDB7g/exec';
      await fetch(GOOGLE_SCRIPT_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          name: formData.fullName,
          email: formData.workEmail
        })
      });
      setIsSuccess(true);
    } catch (err) {
      setError('Something went wrong. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  return <>
      <Navigation data-id="element-133" />

      <main className="wrap report-main" data-id="element-134">
        <article className="report" data-id="element-135">
          {/* frontmatter */}
          <header className="frontmatter" data-id="element-136">
            <div className="fm-cell" data-id="element-137">
              <span className="lbl" data-id="element-138">Page</span>
              <span className="val" data-id="element-139">Contact</span>
            </div>
            <div className="fm-cell" data-id="element-140">
              <span className="lbl" data-id="element-141">Topic</span>
              <span className="val" data-id="element-142">Support & Demo</span>
            </div>
            <div className="fm-cell" data-id="element-143">
              <span className="lbl" data-id="element-144">Status</span>
              <span className="val" data-id="element-145">Active</span>
            </div>
          </header>

          {/* HERO */}
          <section className="hero" style={{
          borderBottom: 'none',
          marginBottom: '16px',
          paddingBottom: '0'
        }} data-id="element-146">
            <div className="kicker" data-id="element-147">Andoe / Contact</div>
            <h1 data-id="element-148">Talk to our team.</h1>
            <p className="lede" data-id="element-149">
              We can set up a platform demo using your choice of prompt.
            </p>
          </section>

          {/* SECTION 01 */}
          <section className="report-section" data-id="element-150">
            <div data-id="element-151">
              <div className="entry" style={{
              borderBottom: 'none'
            }} data-id="element-152">
                {isSuccess ? <div data-id="element-153">
                    <h3 data-id="element-154">Thanks for reaching out!</h3>
                    <p data-id="element-155">We'll follow up shortly.</p>
                  </div> : <form onSubmit={handleSubmit} style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '16px',
                maxWidth: '400px'
              }} data-id="element-156">
                    <div data-id="element-157">
                      <input type="text" name="fullName" placeholder="Full name" required value={formData.fullName} onChange={handleChange} style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: '1px solid var(--rule)',
                    borderRadius: '8px',
                    color: 'var(--ink)',
                    fontFamily: 'inherit',
                    fontSize: '16px',
                    minHeight: '44px'
                  }} data-id="element-158" />
                    </div>
                    <div data-id="element-159">
                      <input type="email" name="workEmail" placeholder="Work email" required value={formData.workEmail} onChange={handleChange} style={{
                    width: '100%',
                    padding: '12px 16px',
                    background: 'transparent',
                    border: '1px solid var(--rule)',
                    borderRadius: '8px',
                    color: 'var(--ink)',
                    fontFamily: 'inherit',
                    fontSize: '16px',
                    minHeight: '44px'
                  }} data-id="element-160" />
                    </div>
                    {error && <p style={{
                  color: 'var(--accent)',
                  fontSize: '14px'
                }} data-id="element-161">
                        {error}
                      </p>}
                    <button type="submit" disabled={isLoading} className="cta" style={{
                  width: 'fit-content',
                  cursor: isLoading ? 'wait' : 'pointer',
                  opacity: isLoading ? 0.7 : 1
                }} data-id="element-162">
                      {isLoading ? 'Sending...' : 'Request Demo'}{' '}
                      <span className="arrow" data-id="element-163">→</span>
                    </button>
                  </form>}
              </div>
            </div>
          </section>

          <Footer data-id="element-164" />
        </article>

        <pre className="json-view" dangerouslySetInnerHTML={{
        __html: jsonHtml
      }} data-id="element-165" />
      </main>
    </>;
}